import achManagementComponent from "./ach_management.component";

let achManagementModule = angular
  .module("achManagement", [])

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $urlRouterProvider.otherwise("/achManagement");

    $stateProvider.state("achManagement", {
      url: "/v2/index.html#/ach-management",
      component: "achManagement",
      data: {
        requireLogin: true,
        requireACL: "ach_management.all",
      },
    });
  })
  .component("achManagement", achManagementComponent).name;

export default achManagementModule;



// WEBPACK FOOTER //
// ./client/app/components/ach_management/index.js